import { useQuery } from '@tanstack/react-query';
import { teamRollupApi } from '@/lib/api/team-rollup';

export const teamRollupKeys = {
  all: ['team-rollup'] as const,
  scoped: (teamId?: string) => [...teamRollupKeys.all, teamId ?? 'org'] as const,
};

/**
 * Director Dashboard: org-wide per-person plan-vs-progress rollup.
 * Pass a `teamId` to scope to that team's subtree.
 */
export function useTeamRollup(teamId?: string) {
  return useQuery({
    queryKey: teamRollupKeys.scoped(teamId),
    queryFn: () => teamRollupApi.get(teamId),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
